import React from "react";
import Grid from "@mui/material/Grid";
import style from "./style";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import { ReactComponent as Download } from "../../../../assets/ViewLeave-images/download.svg";
import { ReactComponent as Print } from "../../../../assets/ViewLeave-images/print.svg";
import { ReactComponent as Send } from "../../../../assets/ViewLeave-images/send.svg";
import {   pdfjs } from "react-pdf";
// import pdfIndex from "./index.pdf"
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import PdfViewer from "../../../../components/PdfViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PayrollSalaryPage = ({ pdf }) => {
  // console.log(pdf,"pdf----")
  const handleDownloadPDF = () => {
    const blob = new Blob([pdf], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "payslip.pdf";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  // const handlePrintPDF = () => {
  //   // Implement printing functionality here
  //   // This could involve using browser printing APIs
  //   // For example:
  //   window.print();
  // };

  // const handleSendPDF = () => {
  //   // Implement sending functionality here
  //   // This could involve integrating with an email service or providing file upload functionality
  //   // For demonstration purposes, let's log a message
  // };

  return (
    <>
      <Grid container>
        <Grid sx={style.mainBox}>
          <Box>
            <Typography variant="body1" sx={style.mainHeading}>
              Payslip
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Button variant="contained" sx={style.printbtn} onClick={handleDownloadPDF}>
              <Box sx={style.downloadIcon}>
                <Print />
              </Box>
              Print
            </Button>

            <Button variant="contained" sx={style.exportbtn} onClick={handleDownloadPDF}>
              <Box sx={style.downloadIcon}>
                <Download />
              </Box>
              Export PDF
            </Button>
            <Button variant="contained" sx={style.downloadbtn} onClick={handleDownloadPDF}>
              <Box sx={style.downloadIcon}>
                <Send />
              </Box>
              Send Invoice
            </Button>
          </Box>
        </Grid>

        <Grid container sx={style.whiteSection} >
          <PdfViewer pdf={pdf}/>
        </Grid>
      </Grid>
    </>
  );
};

export default PayrollSalaryPage;
